/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkProjectCheckCustomerStatusDto } from '../models/work-project-check-customer-status-dto';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceProjectChecksService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceProjectChecksV2ControllerFindByProjectId()` */
  static readonly SelfserviceProjectChecksV2ControllerFindByProjectIdPath = '/v2/selfservice/project-checks/project/{projectId}';

  /**
   * Get the customer-facing project checklist.
   *
   * Returns the customer-visible ProjectCheck items for a project owned by the authenticated contact. Computed on demand and cached in Redis for 5 minutes.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceProjectChecksV2ControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceProjectChecksV2ControllerFindByProjectId$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProjectCheckCustomerStatusDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceProjectChecksService.SelfserviceProjectChecksV2ControllerFindByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProjectCheckCustomerStatusDto>;
      })
    );
  }

  /**
   * Get the customer-facing project checklist.
   *
   * Returns the customer-visible ProjectCheck items for a project owned by the authenticated contact. Computed on demand and cached in Redis for 5 minutes.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceProjectChecksV2ControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceProjectChecksV2ControllerFindByProjectId(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<WorkProjectCheckCustomerStatusDto> {
    return this.selfserviceProjectChecksV2ControllerFindByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProjectCheckCustomerStatusDto>): WorkProjectCheckCustomerStatusDto => r.body)
    );
  }

}
